// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3tkHo","approved":"Status_approved__tQCMm","rejected":"Status_rejected__3sGxd","expired":"Status_expired__3UaQn","label":"Status_label__Z875O"};